import { ISaveDraft, IAnswers, IUpdateFormAnswers } from '../../../models/ISaveDraft';
import { IFormFooter, IFormHeader } from '../../dynamic-form-state';
import { createAction, props } from '@ngrx/store';
import { IFHIRQuestionnaire } from '../../../models/FHIR-Questionnaire';
import { IDynamicFormVersion } from '../../../models/form';

// LOAD
export const loadQuestionnaireShared = createAction(
  '[Render-form] Load Questionnaire',
  props<{ questionnaire: ILoadQuestionnaire }>()
);
export const loadQuestionnaireCompleteShared = createAction(
  '[Render-form] Load Questionnaire Complete',
  props<{ questionnaire: IFHIRQuestionnaire }>()
);
export const loadQuestionnaireSuccess = createAction(
  '[Render-form] Load Questionnaire Success',
  props<{
    questionnaire: IFHIRQuestionnaire;
    formVersionApi: IDynamicFormVersion;
    bookingId: string;
    bookedFormId: string;
  }>()
);
export const loadQuestionnaireFailure = createAction(
  '[Render-form] Load Questionnaire Failed',
  props<{ error: any }>()
);

export const loadQuestionnaireByFormIdCompleteActionShared = createAction(
  '[Render-form] Load Questionnaire By FormId Complete',
  props<{ id: string }>()
);

export const loadFormHeader = createAction('[Render-form] Load form-header to form', props<{ header: IFormHeader }>());
export const loadFormFooter = createAction('[Render-form] Load form-footer to form', props<{ footer: IFormFooter }>());
// RESET
export const resetQuestionnaireShared = createAction('[Render-form] Reset');
// SAVE
export const saveDraft = createAction('[Render-form] Save Draft', props<{ draft: ISaveDraft }>());
export const saveDraftComplete = createAction('[Render-form] Save Draft Complete', props<{ draft: ISaveDraft }>());
export const saveDraftFailure = createAction('[Render-form] Save Draft Failure', props<{ error: string }>());
export const savePreview = createAction('[Render-form] Save Preview', props<{ preview: ISaveDraft }>());
export const savePreviewComplete = createAction(
  '[Render-form] Save Preview Complete',
  props<{ preview: IAnswers[] }>()
);
export const saveResults = createAction('[Render-form] Save Results', props<{ result: ISaveDraft }>());
export const saveResultsComplete = createAction('[Render-form] Save Results Complete', props<{ result: ISaveDraft }>());
export const saveResultFailure = createAction('[Render-form] Save Result Failure', props<{ error: string }>());
export const closeFormAfterSaving = createAction('[Render-form] Close Form After Save');
export const forceSaveDraft = createAction('[Render-form] Set Force Save Draft');
// UPDATE
export const updateForm = createAction('[Render-form] Update Form', props<{ form: IUpdateFormAnswers }>());
export const updateFormComplete = createAction(
  '[Render-form] Update Form Complete',
  props<{ form: IUpdateFormAnswers }>()
);
export const updateFormFailure = createAction('[Render-form] Update Form Failure', props<{ error: string }>());
// GET
export const getDraftResults = createAction(
  '[Render-form] Get Draft Results',
  props<{ bookingId: string; bookedFormId: string }>()
);
export const getDraftResultsComplete = createAction(
  '[Render-form] Get Draft Results Complete',
  props<{ result: IAnswers[] }>()
);
export const getDraftResultsFailure = createAction(
  '[Render-form] Get Draft Results Failure',
  props<{ error: string }>()
);

export interface ILoadQuestionnaire {
  formId: string;
  bookingId: string;
  formVersionId: number;
  bookedFormId: string;
}
